import { useEffect } from 'react';

// Sets the document title and the single description meta tag from index.html.
// Chosen over rendering <title>/<meta> in components so there is never a duplicate tag.
export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag && description) tag.setAttribute('content', description);
  }, [title, description]);
}
